import { zip } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useSetExport from '@components/export/useSetExport';
import { allFiltersSelector, appliedSortSelector } from '@store/metricLens/base/selectors';
import { formatTimestamp } from '@components/export/formatters';
import { getMetricShortName } from '@src/utils/metrics';

function useBaseExport() {
  const filters = useSelector(allFiltersSelector);
  const sortBy = useSelector(appliedSortSelector);

  const headers = ['Labels', 'Timerange', 'Filter'];

  const data = filters.map(({ filter, interval }, idx) => {
    return [
      `F${idx + 1}`,
      `${formatTimestamp(interval.from)} - ${formatTimestamp(interval.to)}`,
      `${filter.name}`,
    ];
  });

  const flippedData = zip(headers, ...data);

  const sortText = useMemo(() => {
    const { metric, filter, order }: any = sortBy;
    const metricName = getMetricShortName({ metricKey: metric });
    return `${metricName} (F${filter + 1}) ${order}`;
  }, [sortBy]);

  flippedData.push(['Sorting on', sortText]);

  useSetExport({
    pageKey: 'metriclens',
    sectionKey: 'ml-base',
    widgetKey: 'ml-base',
    widgetInfo: { title: 'Metriclens Export' },
    data: flippedData,
    headers: [],
  });
}

export default useBaseExport;
